function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import regeneratorRuntime from "regenerator-runtime";
import { Component, Mixins, Watch } from "vue-property-decorator";
import _get from "lodash/get";
import { format } from "date-fns";
import { fetchUserList } from "@/api/system/user";
import Pagination from "@/components/Pagination/index.vue";
import SearchBar from "@/components/SearchV3/index.vue";
import SearchManager from "@com/mixin/search-manager";
import TableList from "@/components/TableList/index.vue";
import { Getter } from "vuex-class";
var UserManager = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(UserManager, _superClass);
    var _super = _createSuper(UserManager);
    function UserManager() {
        _classCallCheck(this, UserManager);
        var _this;
        _this = _super.apply(this, arguments);
        _this.query = {
            page: 1,
            page_size: 15,
            search_field: "",
            keyword: ""
        };
        _this.formItemList = [
            {
                type: "select",
                rules: [],
                prop: "search_field",
                params: {
                    disabled: false,
                    clearable: true,
                    value: "",
                    placeholder: "\u8BF7\u9009\u62E9\u641C\u7D22\u5B57\u6BB5",
                    options: [
                        {
                            value: "id",
                            label: "ID"
                        },
                        {
                            value: "real_name",
                            label: "\u59D3\u540D"
                        },
                        {
                            value: "email",
                            label: "\u90AE\u7BB1"
                        },
                        {
                            value: "department",
                            label: "\u90E8\u95E8"
                        },
                        {
                            value: "role_name",
                            label: "\u4E00\u7EA7\u89D2\u8272\u540D"
                        },
                        {
                            value: "sub_role_name",
                            label: "\u4E8C\u7EA7\u89D2\u8272\u540D"
                        },
                        {
                            value: "third_role_name",
                            label: "\u4E09\u7EA7\u89D2\u8272\u540D"
                        }
                    ]
                }
            },
            {
                type: "input",
                rules: [],
                prop: "keyword",
                subtype: "text",
                params: {
                    disabled: false,
                    readonly: false,
                    clearable: true,
                    value: "",
                    placeholder: "\u8BF7\u8F93\u5165\u5173\u952E\u5B57"
                }
            }
        ];
        _this.users = [];
        _this.tableLoading = false;
        _this.tableConfig = {};
        _this.tableColumnConfig = [
            {
                label: "ID",
                prop: "id",
                width: 70
            },
            {
                label: "Email",
                prop: "email",
                width: 200
            },
            {
                label: "\u59D3\u540D",
                prop: "real_name",
                width: 120
            },
            {
                label: "\u90E8\u95E8",
                prop: "department",
                width: 200
            },
            {
                label: "\u89D2\u8272",
                prop: "role"
            },
            {
                label: "\u6700\u540E\u767B\u5F55 IP",
                prop: "last_ip",
                width: 120
            },
            {
                label: "\u6700\u540E\u767B\u5F55\u65F6\u95F4",
                prop: "last_login",
                width: 150
            }
        ];
        _this.pagination = {
            total: 0
        };
        return _this;
    }
    var _proto = UserManager.prototype;
    _proto.onRouteChange = function onRouteChange() {
        this.getUserList(this.query);
    };
    _proto.mounted = function mounted() {
        this.getUserList(this.query);
    };
    _proto.getUserList = function getUserList(params) {
        var _this = this;
        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var res, ref, list, total;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this.tableLoading = true;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return fetchUserList(params);
                    case 4:
                        res = _ctx.sent;
                        ref = _get(res, "data.data"), list = ref.list, total = ref.total;
                        _this.users = (list || []).map(function(item) {
                            var roles = [
                                item.role_name,
                                item.sub_role_name,
                                item.third_role_name
                            ];
                            return _objectSpreadProps(_objectSpread({}, item), {
                                role: roles.filter(function(role) {
                                    return !!role;
                                }).join("-"),
                                last_login: format(item.last_login * 1000, "YYYY-MM-DD HH:mm:ss")
                            });
                        });
                        _this.pagination.total = total;
                        _this.tableLoading = false;
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        _this.tableLoading = false;
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }))();
    };
    return UserManager;
}(Mixins(SearchManager));
__decorate([
    Getter("userInfo")
], UserManager.prototype, "userInfo", void 0);
__decorate([
    Watch("$route", {
        immediate: true,
        deep: true
    })
], UserManager.prototype, "onRouteChange", null);
UserManager = __decorate([
    Component({
        components: {
            Pagination: Pagination,
            SearchBar: SearchBar,
            TableList: TableList
        }
    })
], UserManager);
export { UserManager as default };
